<template>
    <div class="vue-specialism-tab-button">
        <button @click="handleClick" :class="{ 'active': isActive }">
            <span v-if="hasIcon" class="icon" :style="`mask-image: url('${item.icon}');`"></span>

            <template v-else>
                {{ item.title }}
            </template>
        </button>
    </div>
</template>

<script>
export default {
    name: "SpecialismTabButton",

    props: ['selectedId', 'item'],

    computed: {
        hasIcon() {
            return !_.isEmpty(this.item.icon);
        },

        isActive() {
            return _.isEqual(this.item.id, this.selectedId);
        }
    },

    methods: {
        handleClick() {
            this.$emit('selected-tab', this.item.id);
        }
    }
}
</script>
